import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'
import { GetLaborerSurveyQuestionsResponse } from 'api/laborerPortalAPI/authContract'

type State = { questions: GetLaborerSurveyQuestionsResponse['data'] } & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
  questions: [],
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.GET_LABORER_SURVEY_QUESTIONS_ASYNC,
    Actions.GET_LABORER_SURVEY_QUESTIONS_SUCCESS,
    Actions.GET_LABORER_SURVEY_QUESTIONS_FAIL,
    GetLaborerSurveyQuestionsResponse
  >,
): State => {
  switch (action.type) {
    case Actions.GET_LABORER_SURVEY_QUESTIONS_SUCCESS: {
      return {
        ...state,
        ...action.status,
        questions: action.payload.data,
      }
    }
    case Actions.GET_LABORER_SURVEY_QUESTIONS_ASYNC:
    case Actions.GET_LABORER_SURVEY_QUESTIONS_FAIL: {
      return {
        ...state,
        ...action.status,
        questions: [],
      }
    }
    default:
      return state
  }
}
